import axios from "axios"
import Swal from 'sweetalert2'
const API_URL = "https://portal.ruthshipping.in/api/index.php/api/"
//const API_URL = "http://localhost/myfiles/ruth/api/index.php/api/"
//const API_URL = "/index.php/api/" // local dev: proxied by CRA dev server to 127.0.0.1:8080 (see package.json "proxy")
const axiosApi = axios.create({
  baseURL: API_URL,
})
let swalShown = false;

axiosApi.interceptors.request.use(
  config => {
    const authEmployeeRaw = localStorage.getItem('authEmployee')
    try {
      const authEmployee = JSON.parse(authEmployeeRaw)
      if (authEmployee?.token) {
        config.headers['authorization-key'] = authEmployee.token
      }
      if (authEmployee?.id) {
        config.headers['employee-id'] = authEmployee.id
      }
    } catch (error) {
      console.error("Failed to parse authEmployee from localStorage:", error)
    }
    return config
  },
  error => Promise.reject(error)
)

axiosApi.defaults.headers.common["employee-service"] = 'web-app-employee'
axiosApi.defaults.headers.common["auth-key"] = 'ruth_root'
// axiosApi.defaults.headers.common["Content-Type"] = 'multipart/form-data'

axiosApi.interceptors.response.use(
  response => response,
  error => {
    const { response } = error
    if (!response) {
      console.error("Network error or no response from server:", error)
      return Promise.reject({ message: "Network error. Please try again later." })
    }
    switch (response.status) {
      case 400:
        return Promise.reject({ message: "Bad request. Please check your input." })
      case 401:
        if (!swalShown) {
          swalShown = true;
          Swal.fire({
            icon: 'warning',
            title: 'Unauthorized',
            text: 'You are not authorized. Please login again!',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(() => {
            localStorage.removeItem('authEmployee'); // optional: clear token
            window.location.href = '/';
          });
        }
        // Return a promise that never resolves to stop further then/catch chains
        return new Promise(() => { });
      case 403:
        return Promise.reject({ message: "You do not have permission to access this resource." })
      case 404:
        return Promise.reject({ message: "Resource not found." })
      case 500:
        //window.location.href = '/server-error'
        return Promise.reject({ message: "Internal server error. Please try again later." })
      default:
        return Promise.reject({ message: `An error occurred. Status code: ${response.status}` })
    }
  }
)

export async function get(url, config = {}) {
  try {
    const response = await axiosApi.get(url, { ...config })
    return response.data
  } catch (error) {
    return error.response?.data || { message: "An error occurred while fetching data." }
  }
}
export async function post(url, data, config = {}) {
  try {
    const response = await axiosApi.post(url, data, { ...config })
    return response.data
  } catch (error) {
    return error.response?.data || { message: "An error occurred while posting data." }
  }
}

export async function put(url, data, config = {}) {
  try {
    const response = await axiosApi.put(url, ...data, { ...config })
    return response.data
  } catch (error) {
    return error.response?.data || { message: "An error occurred while updating data." }
  }
}

export async function del(url, config = {}) {
  try {
    const response = await axiosApi.delete(url, { ...config })
    return response.data
  } catch (error) {
    return error.response?.data || { message: "An error occurred while deleting data." }
  }
}


